import qs from "query-string";
import { GetPriceListByCustomerCodeAndProDuctCodeAndFarmIdQuery, GetPriceListByIdsQuery, PriceListResponse } from "types/price-list.type";
import { api, providesList } from ".";

const url = "/price-list";

const defaultInvalidatesTags = [
	{ type: "PriceListByCustomerCodeAndProDuctCodeAndFarmId", id: "LIST" },
	{ type: "PriceList", id: "LIST" },
	{ type: "PriceListByIds", id: "LIST" },
];

export const {
	useLazyGetPriceListByCustomerCodeAndProDuctCodeAndFarmIdQuery,
	useLazyGetPriceListByIdsQuery,
	useGetAllPriceListQuery,
	useLazyGetAllPriceListQuery,
	useCreatePriceListMutation,
	useUpdatePriceListMutation,
	useDeletePriceListMutation,
} = api
	.enhanceEndpoints({
		addTagTypes: ["PriceList", "PriceListByCustomerCodeAndProDuctCodeAndFarmId", "PriceListByIds"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getPriceListByCustomerCodeAndProDuctCodeAndFarmId: build.query<ResponsePaginated<PriceListResponse>, GetPriceListByCustomerCodeAndProDuctCodeAndFarmIdQuery>({
				query: (query) => {
					const newQuery = {
						...query,
						pageNumber: 1,
						pageSize: 100,
					};

					return `${url}?${qs.stringify(newQuery)}`;
				},
				providesTags: (result) => providesList(result?.items, "PriceListByCustomerCodeAndProDuctCodeAndFarmId"),
			}),

			getPriceListByIds: build.query<ResponsePaginated<PriceListResponse>, GetPriceListByIdsQuery>({
				query: (query) => {
					const newQuery = {
						...query,
						pageNumber: 1,
						pageSize: 100,
					};

					return `${url}?${qs.stringify(newQuery)}`;
				},
				providesTags: (result) => providesList(result?.items, "PriceListByIds"),
			}),

			getAllPriceList: build.query<ResponsePaginated<PriceListResponse>, Record<string, any>>({
				query: (query) => {
					if (query) {
						return `${url}?${qs.stringify(query)}`;
					}
					return url;
				},
				providesTags: (result) => providesList(result?.items, "PriceList"),
			}),

			createPriceList: build.mutation<{ success: number; failed: string[] }, Record<string, any>>({
				query: (data) => {
					return {
						url,
						method: "POST",
						body: data,
					};
				},
				invalidatesTags: (result, error) => {
					return error ? [] : (defaultInvalidatesTags as any);
				},
			}),

			updatePriceList: build.mutation<void, Record<string, any>>({
				query: (data) => {
					return {
						url,
						method: "PUT",
						body: data,
					};
				},
				invalidatesTags: (result, error) => {
					return error ? [] : (defaultInvalidatesTags as any);
				},
			}),

			deletePriceList: build.mutation<void, number>({
				query: (id) => {
					return {
						url: `${url}/${id}`,
						method: "DELETE",
					};
				},
				invalidatesTags: (result, error) => {
					return error ? [] : (defaultInvalidatesTags as any);
				},
			}),
		}),
	});
